var _defs, _g, _g2, _g3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCreditCardIcons(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 597.22 122.2",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#253b80;}.cls-10,.cls-2{fill:#fff;}.cls-3{fill:#36495d;}.cls-4{opacity:0;}.cls-5{fill:#ff3d05;}.cls-6{fill:#fa0807;}.cls-7{fill:#fc8f07;}.cls-9{fill:#151011;}.cls-10{stroke:#fff;stroke-width:5px;}.cls-10,.cls-11{stroke-miterlimit:10;}.cls-11,.cls-12{fill:#f95706;}.cls-11{stroke:#f95706;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "visa-color_large",
    "data-name": "visa-color large"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 182.76,
    height: 121.84,
    rx: 15.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M90.85,43.37,83.23,78.59H74.09l7.62-35.22Zm38.3,22.84L134,53l2.77,13.21ZM139.31,78.7h8.46l-7.39-35.22h-7.61A4.16,4.16,0,0,0,129,46.07L115.29,78.7h9.59l1.87-5.25h11.46ZM115.56,67.28c0-9.48-12.76-10.17-12.76-14,0-1.25,1.22-2.59,3.81-2.93a17.13,17.13,0,0,1,9,1.56l1.6-7.61a24.54,24.54,0,0,0-8.53-1.56c-9,0-15.23,4.79-15.23,11.65,0,5.06,4.54,7.88,8,9.55s4.76,2.86,4.72,4.38c0,2.36-2.81,3.43-5.44,3.47a19.06,19.06,0,0,1-9.29-2.29l-1.64,7.62A27.23,27.23,0,0,0,99.87,79c9.56,0,15.84-4.72,15.88-12M78,43.25,63.24,78.47H53.3L46,50.33a3.81,3.81,0,0,0-2.17-3.08,38,38,0,0,0-9-3l.22-1H50.6a4.27,4.27,0,0,1,4.23,3.58l3.8,20.37,9.48-24Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "mastercard-color_large",
    "data-name": "mastercard-color large"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 207.23,
    width: 182.76,
    height: 121.84,
    rx: 15.23
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 224.93,
    y: 12.18,
    width: 147.39,
    height: 97.47
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 279.19,
    y: 29.16,
    width: 38.87,
    height: 63.51
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M283.38,60.92a40.28,40.28,0,0,1,15.23-31.76,40.4,40.4,0,1,0,0,63.51A40.25,40.25,0,0,1,283.38,60.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M360.06,85.93V84.64h.57v-.27H359.3v.27h.53v1.29Zm2.59,0V84.37h-.38l-.46,1.11-.49-1.11h-.38v1.56h.26V84.75l.46,1h.3l.42-1v1.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M363.94,60.92a40.39,40.39,0,0,1-65.33,31.75A40.4,40.4,0,0,0,305.39,36a39.78,39.78,0,0,0-6.78-6.82,40.39,40.39,0,0,1,65.33,31.76Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "discover-color-large"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-207.23, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M789.22,0H636.92a15.23,15.23,0,0,0-15.23,15.23V106.6a15.23,15.23,0,0,0,15.23,15.23h152.3a15.23,15.23,0,0,0,15.23-15.23V15.23A15.23,15.23,0,0,0,789.22,0Zm7.61,106.6a7.61,7.61,0,0,1-7.61,7.62H636.92a7.62,7.62,0,0,1-7.61-7.62V15.23a7.62,7.62,0,0,1,7.61-7.62h152.3a7.61,7.61,0,0,1,7.61,7.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M789.22,0H636.92a15.23,15.23,0,0,0-15.23,15.23V106.6a15.23,15.23,0,0,0,15.23,15.23h152.3a15.23,15.23,0,0,0,15.23-15.23V15.23A15.23,15.23,0,0,0,789.22,0Zm7.61,106.6a7.61,7.61,0,0,1-7.61,7.62H636.92a7.62,7.62,0,0,1-7.61-7.62V15.23a7.62,7.62,0,0,1,7.61-7.62h152.3a7.61,7.61,0,0,1,7.61,7.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M796.83,15.23V106.6a7.61,7.61,0,0,1-7.61,7.62H636.92a7.62,7.62,0,0,1-7.61-7.62V15.23a7.62,7.62,0,0,1,7.61-7.62h152.3A7.61,7.61,0,0,1,796.83,15.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M796.83,67.47v39.14a7.61,7.61,0,0,1-7.61,7.61H667.08C751.14,99.83,796.83,67.47,796.83,67.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M643.89,40.51h-7V64.92h7a13.1,13.1,0,0,0,8.72-2.82A12.26,12.26,0,0,0,657,52.73a12.08,12.08,0,0,0-13.1-12.22Zm5.56,18.31a8.83,8.83,0,0,1-6.51,2.1h-1.26V44.59h1.26a8.93,8.93,0,0,1,6.51,2,8.19,8.19,0,0,1,2.7,6.1A8.3,8.3,0,0,1,649.45,58.82Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 659.2,
    y: 40.47,
    width: 4.76,
    height: 24.44
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M675.64,49.84c-2.85-1-3.8-1.75-3.8-3.05s1.48-2.74,3.54-2.74a5,5,0,0,1,3.8,2l2.48-3.23a10.47,10.47,0,0,0-7.16-2.75,7.16,7.16,0,0,0-7.61,7c0,3.39,1.52,5.1,6,6.7a19.82,19.82,0,0,1,3.32,1.41,2.89,2.89,0,0,1,1.44,2.51,3.5,3.5,0,0,1-3.8,3.47,5.64,5.64,0,0,1-5.18-3.28l-3.09,3a9.49,9.49,0,0,0,8.68,4.65,7.83,7.83,0,0,0,8.38-8C682.61,53.61,681.05,51.82,675.64,49.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M684.17,52.69a12.65,12.65,0,0,0,12.91,12.76,13.09,13.09,0,0,0,6-1.41v-5.6a7.6,7.6,0,0,1-5.75,2.67,8,8,0,0,1-8.23-8.45,8.11,8.11,0,0,1,8-8.38,8,8,0,0,1,6,2.74v-5.6a12.28,12.28,0,0,0-5.87-1.52,12.87,12.87,0,0,0-13,12.79Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "740.87 56.88 734.32 40.47 729.14 40.47 739.49 65.53 742.04 65.53 752.63 40.47 747.45 40.47 740.87 56.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "754.76 64.92 768.32 64.92 768.32 60.77 759.52 60.77 759.52 54.18 767.97 54.18 767.97 50.03 759.52 50.03 759.52 44.62 768.32 44.62 768.32 40.47 754.76 40.47 754.76 64.92"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M781.6,54.64a6.54,6.54,0,0,0,5.56-7c0-4.53-3.16-7.16-8.64-7.16h-7V64.92h4.76V55.09h.57l6.62,9.83h5.79Zm-3.8-2.94h-1.41V44.32h1.41c2.93,0,4.53,1.22,4.53,3.81S780.65,51.7,777.8,51.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M730.55,52.69a13,13,0,1,1-13-13,13,13,0,0,1,13,13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M789.22,41.54a.57.57,0,0,0,.42-.61c0-.42-.27-.65-.8-.65h-.73v2.21h.5v-.91l.69.91h.57Zm-.46-.31h0V40.7h0c.23,0,.38,0,.38.23s.08.3-.3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M789,39.48a1.89,1.89,0,0,0-1.31.58,1.86,1.86,0,0,0-.52,1.33,1.91,1.91,0,0,0,3.81,0,1.87,1.87,0,0,0-2-1.91Zm1,3a1.27,1.27,0,0,1-1,.42,1.49,1.49,0,0,1-1.48-1.52A1.5,1.5,0,0,1,789,39.83a1.49,1.49,0,0,1,1,.47,1.56,1.56,0,0,1-.1,2.19Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardIcons);
export default __webpack_public_path__ + "static/media/credit-card-icons.06953452.svg";
export { ForwardRef as ReactComponent };